// extracted by mini-css-extract-plugin
module.exports = {"title":"LinksSection_title__Pb_4s","list":"LinksSection_list__dj_pc","item":"LinksSection_item__3NYCX","link":"LinksSection_link__mmfts"};